import { render, staticRenderFns } from "./OrigenDeudaList.vue?vue&type=template&id=31f1aaf2"
import script from "./OrigenDeudaList.vue?vue&type=script&lang=js"
export * from "./OrigenDeudaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports